import { render, staticRenderFns } from "./CostMessageBox.vue?vue&type=template&id=74ac5e4d"
import script from "./CostMessageBox.vue?vue&type=script&lang=js"
export * from "./CostMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports